// extracted by mini-css-extract-plugin
export default {"wrapper":"mXv5P","filterInput":"N2S7D","total":"uAqa5","nothingFound":"NeN5Q"};